var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cmg-rewards-achievements"},[_c('cmg-rewards-achievements-header'),_c('cmg-rewards-achievements-body',{attrs:{"achievementYears":_vm.achievementYears}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }